import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .CampaignsTable {
    .ReactDataTable__wrapper {
      .ReactDataTable {
        tr {
          grid-template-columns:
            minmax(40px, 0.5fr) /* logo */
            minmax(200px, 2fr) /* title */
            minmax(100px, 1fr) /* is_active */
            minmax(100px, 1fr) /* is_default */
            minmax(120px, 1fr); /* actions */
        }

        .ReactDataTable__tbody-row {
          height: 65px;
        }

        .ReactDataTable__tbody-cell {
          display: flex;
          align-items: center;

          &:first-child {
            justify-content: center;
            .CampaignsTable__logo {
              width: 28px;
              height: 28px;
              border-radius: 50%;
              object-fit: cover;
            }
          }

          &:nth-child(2) {
            font-weight: 500; /* title */
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    /* --- Responsive layout --- */
    .ResponsiveTable__thead {
      min-width: 320px !important;

      span {
        text-align: center;
        padding: 5px 0;

        &:first-child {
          flex: 1; /* logo */
        }

        &:nth-child(2) {
          flex: 10; /* title */
        }

        &:nth-child(3) {
          flex: 6; /* actions */
        }
      }
    }

    .ResponsiveTable__row {
      .ResponsiveTable__row-item {
        display: flex;
        align-items: center;

        &:first-child {
          flex: 1; /* logo */
          justify-content: center;

          .CampaignsTable__logo {
            width: rem(30px);
            height: rem(30px);
            border-radius: 50%;
            object-fit: cover;
          }
        }

        &:nth-child(2) {
          flex: 10; /* title */
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
        }

        &:nth-child(3) {
          flex: 6; /* actions */
          justify-content: center;
        }
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .CampaignsTable {
    }
  `;
};

export { staticStyles, getDynamicStyles };
